import React from 'react'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'
import Card, { CardContent } from 'material-ui/Card'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'
import { Field as ReduxFormField } from 'redux-form'
import isEqual from 'lodash/isEqual'

const styles = theme => ({
  formCard: {
    marginTop: theme.spacing.unit,
    marginLeft: 2 * theme.spacing.unit,
    marginRight: 2 * theme.spacing.unit,
    marginBottom: 2 * theme.spacing.unit
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing.unit
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: theme.spacing.unit
  },
  button: {
    marginTop: theme.spacing.unit,
    alignSelf: 'center'
  },
  error: {
    marginTop: theme.spacing.unit
  }
})

const renderField = classes => ({
  input,
  label,
  type,
  meta: { touched, error, warning }
}) => {
  return (
    <div className={classes.formGroup}>
      <TextField
        {...input}
        label={label}
        type={type}
        error={!!(touched && (error || warning))}
        helperText={touched && (error || warning)}
      />
    </div>
  )
}

export const validation = {
  required: value => (value ? undefined : 'Required'),
  validateEmail: email =>
    email && email.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i)
      ? undefined
      : 'Invalid e-mail address.',
  minLength: min => value =>
    value && value.length < min
      ? `Must be ${min} characters or more.`
      : undefined,
  validatePasswordConfirm: passwordFieldName => (value, allValues) =>
    allValues[passwordFieldName] === value ? undefined : 'Password do no match.'
}

export const FormCard = withStyles(styles)(({ classes, title, children }) => (
  <Card className={classes.formCard}>
    <CardContent>
      {title && (
        <Typography type="headline" component="h2">
          {title}
        </Typography>
      )}
      {children}
    </CardContent>
  </Card>
))

export const SubmitButton = withStyles(
  styles
)(({ classes, text, ...props }) => (
  <Button color="primary" type="submit" className={classes.button} {...props}>
    {text}
  </Button>
))

export const Form = withStyles(styles)(({ classes, ...props }) => (
  <form className={classes.form} {...props} />
))

export const Field = withStyles(styles)(({ classes, ...props }) => {
  // Dirty workaround: the function passed to `component` property must not
  // change, otherwise the focus of the field will be lost as soon as the
  // first character is typed. So until the classes change, we define the
  // render function one time for all.
  if (!Field.renderFieldWithClasses || !isEqual(Field.classes, classes)) {
    Field.classes = classes
    Field.renderFieldWithClasses = renderField(classes)
  }
  return <ReduxFormField component={Field.renderFieldWithClasses} {...props} />
})

export const Error = withStyles(styles)(({ classes, ...props }) => (
  <Typography
    className={classes.error}
    color="secondary"
    type="body1"
    {...props}
  />
))



// WEBPACK FOOTER //
// ./src/helpers/form.js